import BaseManager from '../../../managers/BaseManager';
class DashUserNotificationsManager extends BaseManager {
    static async loadNotifications() {
        return await BaseManager.get(DashUserNotificationsManager.URL);
    }
    static async dismissAllNotifications() {
        return await BaseManager.post(`${DashUserNotificationsManager.URL}/${DashUserNotificationsManager.DISMISS_ACTION}`);
    }
    static async dismissNotification(id) {
        return await BaseManager.post(`${DashUserNotificationsManager.URL}/${id}/${DashUserNotificationsManager.DISMISS_ACTION}`);
    }
}
DashUserNotificationsManager.URL = '/o/v1/notifications';
DashUserNotificationsManager.DISMISS_ACTION = 'dismiss';
export default DashUserNotificationsManager;
//# sourceMappingURL=UserNotificationsManager.js.map